(function ($, XTT) {
	'use strict';

	XTT.home = {
		_autoload: [
			'home'
		],

		home: function () {
		}

	};

})
(jQuery, XTT); 